// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "title-EJQ9e";
var _3 = "close__text-3JijS";
var _4 = "header_wrapper-UCrSY";
var _5 = "close__icon-35vNH";
export { _1 as "__esModule", _2 as "title", _3 as "close__text", _4 as "header_wrapper", _5 as "close__icon" }
export default { "__esModule": _1, "title": _2, "close__text": _3, "header_wrapper": _4, "close__icon": _5 }
